import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { getApp } from 'firebase/app';
import { getAuth, deleteUser } from 'firebase/auth';
import { deleteDoc, doc, getFirestore } from 'firebase/firestore';
import { InterestOptions } from 'src/shared/constants/interestOptions';
import { OrganizationService } from '../services/organization.service';

@Component({
  selector: 'app-createorg',
  templateUrl: './createorg.component.html',
  styleUrls: ['./createorg.component.css', '../../shared/styles/formStyles.css']
})
export class CreateorgComponent {

  name: string | undefined;
  description: string | undefined;
  interests: string[] | undefined;

  interestOptions: { [key: string]: string } = InterestOptions;
  interestKeys: string[] = Object.keys(this.interestOptions);

  private app = getApp();
  private auth = getAuth(this.app);

  constructor(
    private router: Router,
    private orgService: OrganizationService
  ) { }

  onCheckChange(event: Event, key: string) {
    if (!event.target) return;

    this.interests = this.interests ?? [];

    if ((event.target as HTMLInputElement).checked) {
      this.interests.push(key);
    } else {
      const index = this.interests.indexOf(key, 0) ?? -1;
      if (index > -1) {
        this.interests.splice(index, 1);
      }
    }
  }

  submit(): void {

    const name = this.name ?? "";
    const description = this.description ?? "";
    const interests = this.interests ?? [];
    this.orgService.addOrgInfo(name, description, interests);
    const useracc = this.auth.currentUser;
    const email = useracc?.email;

    console.log(useracc);
    if (useracc != null) {

      const user = email?.split("@");

      if (user != null) {
        const userToDelete = doc(getFirestore(getApp()), "users", user[0]);
        deleteDoc(userToDelete);
      }

    }
    console.log(interests);

    this.router.navigate(['/homepage']);
  }

}
